/**
 * Order Contents Page
 *
 * This page renders a breadcrumb navigation and the OrderContentsForm component.
 *
 * The orderId param is required.
 */
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { getGetOrderQueryOptions } from "@/requests/gen/react-query/order";
import OrderContentsForm from "./-form";
import { OrderCrumbs } from "../../-crumbs";

export const Route = createFileRoute(
  "/_private/_patient-360/order/$orderId/contents/",
)({
  loader: ({ context: { queryClient }, params: { orderId } }) =>
    queryClient.ensureQueryData(getGetOrderQueryOptions(orderId)),
  component: OrderContentsPage,
});

function OrderContentsPage() {
  const { orderId } = Route.useParams();
  const navigate = useNavigate();

  const { data: order } = useSuspenseQuery(
    suspenseOptions(getGetOrderQueryOptions(orderId)),
  );

  return (
    // Page layout
    <div>
      <title>{`Order Contents ${orderId} - Legrande Health Portal`}</title>
      <OrderCrumbs canEdit />

      {/* Order Contents form */}
      <Card>
        <CardHeader>
          <CardTitle>Order Contents</CardTitle>
          <CardDescription>
            Select from the products below and then click next.
          </CardDescription>
          <CardAction>
            <div className="flex gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() =>
                  navigate({
                    to: "/order/$orderId/edit",
                    params: { orderId },
                  })
                }
              >
                Back
              </Button>
              <Button type="submit" form="order-contents-form">
                Next
              </Button>
            </div>
          </CardAction>
        </CardHeader>
        <CardContent>
          {/* Wait until the order is loaded */}
          {order && <OrderContentsForm order={order} />}
        </CardContent>
      </Card>
    </div>
  );
}
